import React from "react";

const photos = [
  {
    src: "https://customer-assets.emergentagent.com/job_assisted-living-hub-1/artifacts/stxxf494_IMG_0299.jpeg",
    label: "Common Room",
    span: "lg:col-span-8",
    h: "h-[420px]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_assisted-living-hub-1/artifacts/e8sukabm_IMG_0298.jpeg",
    label: "Courtyard & Pathways",
    span: "lg:col-span-4",
    h: "h-[420px]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_assisted-living-hub-1/artifacts/6wervkxl_IMG_5670.jpeg",
    label: "Dining Room",
    span: "lg:col-span-6",
    h: "h-[360px]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_assisted-living-hub-1/artifacts/cuezksfe_IMG_0301.jpeg",
    label: "Resident Living Area",
    span: "lg:col-span-6",
    h: "h-[360px]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_assisted-living-hub-1/artifacts/l7j19a3o_IMG_0302.jpeg",
    label: "Sunroom & Sitting Area",
    span: "lg:col-span-5",
    h: "h-[380px]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_assisted-living-hub-1/artifacts/eheyzqe9_IMG_0303.jpeg",
    label: "Library & Puzzle Room",
    span: "lg:col-span-7",
    h: "h-[380px]",
  },
];

const GallerySection = () => {
  return (
    <section id="gallery" className="gallery-bg" data-testid="gallery-section">
      <div className="container-hc py-20 md:py-28">
        <div className="max-w-3xl">
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[color:var(--hc-navy)]">
            Our Community in Pictures
          </h2>
          <p className="mt-6 text-lg text-[color:var(--hc-navy)]/75 leading-relaxed">
            Brick exterior, manicured grounds, a sun-filled common room, a warm dining room,
            and private resident apartments — see the home we've built for the families we
            serve.
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-12 gap-6">
          {photos.map((p, i) => (
            <div
              key={i}
              className={`relative ${p.span} rounded-[24px] overflow-hidden shadow-xl border-[3px] border-white group`}
              data-testid={`gallery-${p.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              {p.bgSize ? (
                <div
                  className={`w-full ${p.h} transition-transform duration-700 group-hover:scale-105`}
                  role="img"
                  aria-label={p.label}
                  style={{
                    backgroundImage: `url('${p.src}')`,
                    backgroundSize: p.bgSize,
                    backgroundPosition: p.bgPosition,
                    backgroundRepeat: "no-repeat",
                  }}
                />
              ) : (
                <img
                  src={p.src}
                  alt={p.label}
                  className={`w-full ${p.h} object-cover transition-transform duration-700 group-hover:scale-105`}
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-[#1f4a35]/85 via-[#1f4a35]/10 to-transparent pointer-events-none" />
              <div className="absolute bottom-5 left-5 right-5">
                <div className="font-serif-display text-2xl text-white">{p.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
